import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="bg-[#FAFAFA] py-48">
      <div className="w-4/5 mx-auto">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-24 h-px bg-[#2B2D33] mx-auto mb-8"></div>
          <h2
            className="text-5xl font-light text-[#2B2D33] leading-tight mb-10"
            style={{ fontFamily: 'Crimson Text, serif' }}
          >
            Where EBITDA Disappears Quietly
          </h2>
          <p className="text-lg text-[#6B6D72] leading-relaxed mb-14 max-w-2xl mx-auto">
            If you suspect margin erosion but lack structured visibility, we can help quantify the gap and build a disciplined roadmap.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-4 bg-[#2B2D42] text-white px-8 py-4 rounded-full font-medium hover:bg-[#1F2132] transition-colors cursor-pointer whitespace-nowrap"
          >
            <span>Request a Free Confidential Discussion</span>
            <div className="w-9 h-9 rounded-full bg-white flex items-center justify-center">
              <i className="ri-arrow-right-line text-[#2B2D42] text-lg"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
